<template functional>
  <div :class="['sprite-icon', `sprite-${props.name}`]" />
</template>

<script>
export default {
  name: 'SpriteIcon',
  props: {
    name: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import './sprite@1x.scss';
@import './sprite@2x.scss';

@each $spriteName, $spriteOptions in $sd-icons {
  .sprite-icon.sprite-#{$spriteName} {
    @include sd-sprite($spriteName);
  }
}

@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
  @each $spriteName, $spriteOptions in $hd-icons {
    .sprite-icon.sprite-#{$spriteName} {
      @include hd-sprite($spriteName);
    }
  }
}
</style>
